import moment from "moment"
import { useEffect, useState } from "react"
import { dictionaryCRUD } from "../../../../actions/dictionary"


export const PersonalDetail = (props) => {

  const {data, step1, setStep1} = props

  const [gender, setGender] = useState(null)

  useEffect(() => {
    if (!data || !data.dictionary_gender) return;

    setTimeout(() => {
      dictionaryCRUD.loadDictionaryItemById(data.dictionary_gender).then((resp) => {
        setGender(resp.data && resp.data.dictionary_item_name_en)
      })
    },500)
  },[data])

  return (
    <>
      <div>
        <div className="row">
            <div className="col-lg-4 col-sm-12">
                <div className="mb-3">
                    <label className="form-label" >Full Name</label>
                    <input type="text" className="form-control border-dashed" id="steparrow-gen-info-email-input" value={data.full_name ? (data.full_name).toUpperCase() : 'N/A'}  readOnly/>
                </div>
            </div>
            <div className="col-lg-4 col-sm-12">
                <div className="mb-3">
                    <label className="form-label" >Data of Birth</label>
                    <input type="text" className="form-control border-dashed" id="steparrow-gen-info-username-input" value={data.dob ? moment(data.dob).format("D MMM, YYYY") : 'N/A'}  readOnly/>
                </div>
            </div>
            <div className="col-lg-4 col-sm-12">
              <div className="mb-3">
                <label className="form-label" >Place of Birth</label>
                <input type="text" className="form-control border-dashed" id="steparrow-gen-info-password-input" value={data.pob ? (data.pob).toUpperCase() : 'N/A'} readOnly/>
              </div>
            </div>
        </div>
        <div className="row">
            <div className="col-lg-4 col-sm-12">
                <div className="mb-3">
                    <label className="form-label" >Gender</label>
                    <input type="text" className="form-control border-dashed" id="steparrow-gen-info-email-input" value={gender ? (gender).toUpperCase() : 'N/A'} readOnly/>
                </div>
            </div>
            <div className="col-lg-4 col-sm-12">
                <div className="mb-3">
                    <label className="form-label" >Phone Number</label>
                    <input type="text" className="form-control border-dashed" id="steparrow-gen-info-username-input" value={data.phone_number ? (data.phone_number).toUpperCase() : 'N/A'} readOnly/>
                </div>
            </div>
            <div className="col-lg-4 col-sm-12">
              <div className="mb-3">
                <label className="form-label" >Email</label>
                <input type="text" className="form-control border-dashed" id="steparrow-gen-info-password-input" value={data.emaila_ddress ? (data.emaila_ddress).toUpperCase() : 'N/A'} readOnly/>
              </div>
            </div>
        </div>
      </div>
      <div className="d-flex align-items-start gap-3 mt-4">
          <button type="button" className="btn btn-success btn-label right ms-auto" onClick={() => setStep1(!step1)} ><i className="bi bi-chevron-double-right label-icon align-middle fs-16 ms-2"></i>Next</button>
      </div>
    </>
  )

}